import { ReactNode } from 'react';

import styles from './FloatingBanner.module.css';

// Плашка вверху по центру поверх шапки сайта и модалок: связь, микрофон, звук. Всегда на
// виду, где бы ни был скролл; на узком экране текст переносится, действие уходит на свою строку
export function FloatingBanner({ children }: { children: ReactNode }) {
  return (
    <div className={styles.banner} role="status">
      {children}
    </div>
  );
}
